import { render, staticRenderFns } from "./PricingRuleTabs.vue?vue&type=template&id=c9a57b98&scoped=true"
import script from "./PricingRuleTabs.vue?vue&type=script&lang=js"
export * from "./PricingRuleTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a57b98",
  null
  
)

export default component.exports